import LikeScore from '@/enums/LikeScore';

const state = {
  reviewsSourceName: 'review',
  isLoadingLike: false
};

const getters = {
  reviews(state, _getters, rootState) {
    switch (state.reviewsSourceName) {
      case 'review':
        return rootState['review']['rawReviews'];
      case 'productMediaReviewCollage':
        return rootState['productMediaReviewCollage']['reviews'];
      default:
        return null;
    }
  },
  reviewsMutationType(state) {
    switch (state.reviewsSourceName) {
      case 'review':
        return 'review/SET_REVIEWS';
      case 'productMediaReviewCollage':
        return 'productMediaReviewCollage/SET_REVIEWS';
      default:
        return null;
    }
  },
  currentPlusLikesCount: () => review => {
    const parentPlusLikesCount = review.parent_plus_likes_count || 0;
    return review.plus_likes_count + parentPlusLikesCount;
  },
  currentMinusLikesCount: (_state, getters) => review => {
    const parentLikesCount = review.parent_likes_count || 0;
    const totalLikesCount = review.likes_count + parentLikesCount;
    return totalLikesCount - getters.currentPlusLikesCount(review);
  }
};

const mutations = {
  SET_LOADING_LIKE(state, isLoadingLike) {
    state.isLoadingLike = isLoadingLike;
  },
  SET_REVIEWS_SOURCE_NAME(state, reviewsSourceName) {
    state.reviewsSourceName = reviewsSourceName;
  }
};

const actions = {
  toggleLike({ dispatch, rootGetters }, { review }) {
    const isLoggedIn = rootGetters['session/isLoggedIn'];

    if (!isLoggedIn) {
      return dispatch('widget/confirmForLogin', {}, { root: true });
    }

    return review.like_score === LikeScore.LIKE
      ? dispatch('deleteLike', { reviewId: review.id })
      : dispatch('createLike', { reviewId: review.id, score: LikeScore.LIKE });
  },
  createLike({ commit, getters, rootState }, { reviewId, score }) {
    commit('SET_LOADING_LIKE', true);
    return rootState.api
      .createLike(reviewId, score)
      .then(({ data }) => {
        const renewedReviews = getters.reviews.map(review => {
          if (review.id !== reviewId) return review;

          return {
            ...review,
            like_score: data.like_score,
            likes_count: data.likes_count,
            plus_likes_count: data.plus_likes_count
          };
        });
        commit(
          getters.reviewsMutationType,
          { reviews: renewedReviews },
          { root: true }
        );
      })
      .finally(() => commit('SET_LOADING_LIKE', false));
  },
  deleteLike({ commit, getters, rootState }, { reviewId }) {
    commit('SET_LOADING_LIKE', true);
    return rootState.api
      .deleteLike(reviewId)
      .then(({ data }) => {
        const renewedReviews = getters.reviews.map(review => {
          if (review.id !== reviewId) return review;

          return {
            ...review,
            like_score: 0,
            likes_count: data.likes_count,
            plus_likes_count: data.plus_likes_count
          };
        });
        commit(
          getters.reviewsMutationType,
          { reviews: renewedReviews },
          { root: true }
        );
      })
      .finally(() => commit('SET_LOADING_LIKE', false));
  }
};

export default { namespaced: true, state, mutations, actions, getters };
